import {TargetGroup} from 'shared/models/target-groups/target-group';
import {Question} from './question';

export class Dialog {
  public _id: string;
  public title: {
    de: string;
    en: string;
  };
  public description: {
    de: string;
    en: string;
  };
  public active: boolean;
  public urgent: boolean;
  public goal: boolean;
  public contSuggest: boolean;
  public clone: boolean;
  public startDate: Date;
  public endDate?: Date;
  public intervalValue: number;
  public intervalUnit: 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
  public activeDuration: number;
  public isDistributed: false;
  public targetGroup: TargetGroup;
  public questions: Array<Question>;

  constructor(id?: string) {
    this._id = id;
    this.title = {de: '', en: ''};
    this.description = {de: '', en: ''};
    this.active = false;
    this.urgent = false;
    this.goal = false;
    this.contSuggest = false;
    this.isDistributed = false;
    this.questions = [];
    this.targetGroup = new TargetGroup();
    this.startDate = new Date();
  }

  public static create(data: Dialog): Dialog {
    const dialog: Dialog = new Dialog();
    dialog._id = data._id;
    dialog.title = data.title;
    dialog.description = data.description;
    dialog.active = data.active;
    dialog.urgent = data.urgent;
    dialog.goal = !!data.goal;
    dialog.contSuggest = !!data.contSuggest;
    dialog.activeDuration = data.activeDuration;
    dialog.isDistributed = data.isDistributed;
    dialog.targetGroup = data.targetGroup;
    dialog.questions = data.questions.map((question) => {
      return Question.create(question);
    });
    dialog.intervalUnit = data.intervalUnit;
    dialog.intervalValue = data.intervalValue;

    if (data.startDate) {
      dialog.startDate = new Date(data.startDate);
    }

    if (data.endDate) {
      dialog.endDate = new Date(data.endDate);
    }

    return dialog;
  }
}

export class ContentUsage {
  public _id: number;
  public title: {
    de: string;
    en: string;
  };
  public active: boolean;
  public days: Array<number>;
}





// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/dialog.ts